/**
 * B1085 (Eric 2026-09-05 SPEC STRICK PROD) — Cache d'appels partagé.
 *
 * Mesure à l'origine : l'ouverture d'une page vidéo déclenchait 28 appels API
 * pour environ 7,5 s de temps serveur cumulé, dont plusieurs identiques
 * (`/api/favorites` deux fois) ou déjà obtenus sur l'écran précédent
 * (`/api/pathways`, la liste des vidéos). Chaque appel coûte en plus un
 * plancher de ~74 ms de traversée (proxy, authentification, garde
 * multi-organisation), donc supprimer un appel vaut mieux que l'accélérer.
 *
 * Deux garde-fous : les requêtes simultanées sur la même URL partagent la
 * même promesse (pas de rafale), et toute mutation invalide explicitement les
 * clés concernées — un cache qu'on ne peut pas vider est un bogue en attente.
 */
const store = new Map();

const now = () => Date.now();

export function cachedGet(axios, url, { ttl = 60_000, config } = {}) {
  const entry = store.get(url);
  if (entry) {
    if (entry.promise) return entry.promise;
    if (now() - entry.at < ttl) return Promise.resolve(entry.value);
  }
  const promise = axios
    .get(url, { withCredentials: true, ...(config || {}) })
    .then((res) => {
      store.set(url, { value: res, at: now() });
      return res;
    })
    .catch((err) => {
      store.delete(url);
      throw err;
    });
  store.set(url, { promise, at: now() });
  return promise;
}

/** Invalide toutes les clés contenant ce fragment d'URL. */
export function invalidateCache(fragment) {
  if (!fragment) {
    store.clear();
    return;
  }
  for (const key of [...store.keys()]) {
    if (key.includes(fragment)) store.delete(key);
  }
}

export const _cacheSize = () => store.size;
